import styled from 'styled-components';
import { ContainerRef } from '../styles';

export const Container = styled(ContainerRef)`

  align-items: flex-start;
  justify-content: stretch;
`;

export const Field = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start !important;
  width: 100%;
   
  position: relative;
 

  > label {
    margin-bottom: 5px;
    display: flex;
    max-width: 200px;
    min-width: 150px;
  }

  p, input{
    padding: 5px;
  }

  > div {
    width: 100%;
    margin: 0 5px;

    > input,
    > select,
    > textarea {
      margin-top: 0;
    }
  }
`;